module.exports = __webpack_public_path__ + "static/media/imagePagePlaceholderPostQuiz.b16b7f13.svg";